<template>
  <div class="action">
    <button class="action__btn" :title="label" @click="$emit('click', $event)">
      <span class="action__icon">
        <component :is="icon" />
      </span>
      <span :class="['action__label', { hide: hideLabel }]">
        {{ label }}
      </span>
    </button>
  </div>
</template>

<script>
import Vue from 'vue';
export default {
  name: 'QuickActionItem',
  props: {
    icon: { required: true, type: Vue.component },
    label: {
      type: String,
      default: '',
    },
    hideLabel: {
      default: false,
      required: false,
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
